import { graphql } from "../gql";

export const batchClaimDocumentationStateQueryDoc = graphql(`
  query batchClaimDocumentationStateQuery($batchClaimIds: [UUID!]) {
    batchClaims(filter: { id: { in: $batchClaimIds } }) {
      nodes {
        ...batchClaimState
      }
    }
  }
`);
